import React from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { MFASettings } from '../components/settings/MFASettings';

export default function MFASettingsPage() {
  return (
    <DashboardLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <MFASettings />
      </div>
    </DashboardLayout>
  );
}
